"use strict";
exports.__esModule = true;
function retry(fn, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.retries, retries = _c === void 0 ? 5 : _c, _d = _b.interval, interval = _d === void 0 ? 10000 : _d;
    return new Promise(function (resolve, reject) {
        fn()
            .then(resolve)["catch"](function (error) {
            setTimeout(function () {
                if (retries === 0) {
                    reject(error);
                    return;
                }
                // Passing on "reject" is the important part
                retry(fn, {
                    retries: retries - 1,
                    interval: interval
                }).then(resolve, reject);
            }, interval);
        });
    });
}
exports["default"] = retry;
//# sourceMappingURL=retry.js.map